import React from "react";
import Youtube from "react-youtube";
import styled from 'styled-components';
import BaseModal, { MODALSIZES } from "../BaseModal";

const ModalContent = styled.div`
   .video-modal-close {
      font-size: 1.8rem;
   }
   .embed-responsive-item {
      max-height: 70vh;
   }

   .aspect-16-9 {
        aspect-ratio: 16 / 9;
   }
`;

interface IYoutubeModalProps {
    modalId: string;
    videoId: string;
    autoPlay?: boolean;
    subtitles?: boolean;
    mute?: boolean;
    loop?: boolean;
}

export default (props: IYoutubeModalProps) => {
    return (
        <BaseModal backdropClassName={"modal-backdrop-glass"} modalId={props.modalId} modalSize={MODALSIZES.VIDEO}>
            <ModalContent>
                <Youtube
                    className="embed-responsive-item w-100 h-auto aspect-16-9"
                    videoId={props.videoId}
                    opts={{
                        playerVars: {
                            autoplay: props.autoPlay ? 1 : 0,
                            cc_load_policy: props.subtitles ? 1 : null,
                            mute: props.mute ? 1 : 0,
                            loop: props.loop ? 1 : 0,
                            playlist: props.loop ? props.videoId : null,
                        }
                    }}
                />
            </ModalContent>
        </BaseModal>
    );
};

